/**
 * Created by dwebster on 5/3/17.
 */
import React, {Component } from 'react';
import renderHTML from 'react-render-html';
import Intro from './Intro';
import CityCredits from './CityCredits';
import { slug } from './cities/Sections';
import {cityList} from './cities/Cities';

const GLOBAL_CREDITS_DATA  = [
  [
    "Global Organizers", [
    ["President", '<a href="http://treedub.org">Chris Willmore</a>'],
    ["VP Puzzles", '<a href="https://www.idleloop.com/content/">Cathy Saxton</a>'],
    ["Story Lead", "Allen Cohn"],
    ["Webmaster", "Dann Webster"]
  ]
  ],
  [
    "Puzzle Authors", [
      ["Puzzle 1", "Dann Webster & Chris Willmore"],
      ["Puzzle 2", "Jonah Ostroff"],
      ["Puzzle 3", "Jon Napolitano"],
      ["Puzzle 4", "Wil Zambole"],
      ["Puzzle 5", "Ian Wilbanks"],
      ["Puzzle 6", "Mark Larson"],
      ["Puzzle 7", "Jonah Ostroff"],
      ["Puzzle 8", "Tim Lipus"],
      ["Puzzle 9", "Sean Gugler"],
    ]
  ],
  [
    "Play Testers", [
      "Sean Gugler",
      "Jesse Morris",
      "Jonah Ostroff",
      "Tom Saxton",
      "Atlanta GC Team",
      "Boston GC Team",
      "DC GC Team",
      "Enschede GC Team",
      "Fremont GC Team",
      "London GC Team",
      "Minneapolis GC Team",
      "NYC GC Team",
      "Provo GC Team",
      "Seattle GC Team",
      "St. Louis GC Team",
      "Vienna GC Team"
    ]
  ],
  ["Special Thanks", [
    "Debbie Goldstein",
    "Yuan Niu",
    "Tom Saxton",
    "Tinsley Webster",
    "Channing Wong"
  ]],
  ["More Special Thanks", [
    "<a href='http://cluekeeper.com'>ClueKeeper</a>",
    "<a href='http://dickblick.com'>Dick Blick Art Materials</a>",
    "<a href='http://www.fedex.com/us/office/printing-services.html'>FedEx Office Print & Ship Center</a>",
    "<a href='http://FreeConferenceCall.com'>FreeConferenceCall.com</a>",
    "<a href='http://google.com'>Google</a>",
    "<a href='http://kathleenkowal.wordpress.com'>Kathleen Kowal Design & Illustration</a>",
    "<a href='http://mapleleafscreenprinting.com'>Maple Leaf Screen Printing</a>",
    "<a href='http://pololu.com'>Pololu Robotics & Electronics</a>",
    "<a href='http://scribus.net'>Scribus</a>",
  ]],
  ["City Organizations", [
    "<a href='#atlanta'>Atlanta</a>",
    "<a href='#austin'>Austin</a>",
    "<a href='#boston'>Boston</a>",
    "<a href='#chicago'>Chicago</a>",
    "<a href='#davis'>Davis</a>",
    "<a href='#fremont'>Fremont</a>",
    "<a href='#london'>London</a>",
    "<a href='#los-angeles'>Los Angeles</a>",
    "<a href='#minneapolis'>Minneapolis</a>",
    "<a href='#new-york'>New York</a>",
    "<a href='#provo'>Provo</a>",
    "<a href='#san-francisco'>San Francisco</a>",
    "<a href='#seattle'>Seattle</a>",
    "<a href='#st-louis'>St. Louis</a>",
    "<a href='#washington-dc'>Washington, D. C.</a>",
    "<a href='#enschede'>Enschede</a>",

  ]]
];



const TITLE = "DASH 9 Credits";
const TEXT = "We would like to thank these members of the puzzle community that made DASH 9 such a success:";

class Credits extends Component {
  render() {
    const globalContent = this.sections(GLOBAL_CREDITS_DATA);
    const cityContent = cityList.map( (city) => { return (<CityCredits key={`${city.slug}-credits`} citySlug={city.slug} />);});
    return (
        <div>
          <Intro title={TITLE} text={TEXT} />
          <div className="global indent">
            <article className="col-lg-12 col-md-12 col-sm-12 bookstoreBox">
              <h2><span className="credits-header">Global Credits</span></h2>
            </article>
            <div className="container">
              <div className="row">
                {globalContent}
              </div>
            </div>
            <div className="container">
              <div className="row">
                {cityContent}
              </div>
            </div>
          </div>
        </div>
    );
  }

  sections(creditsData) {
    const content = creditsData.map( (data) => this.section(data[0], data[1]) );
    return (
      <div>
        {content}
      </div>
    );
  }

  section(title, items) {
    const itemMarkup = items.map( (item, index) => this.item(item, index));
    return (
          <article key={slug(title)} className="col-lg-4 col-md-4 col-sm-4 who-box" >
            <h2><span className="credits-header">{title}</span></h2>
            <ul className="list6 credits-list">
              {itemMarkup}
            </ul>
          </article>
    );
  }

  item(item, index) {
    const key = `li-key-${index}`;
    return typeof item === "string" ?
          (<li key={key}><strong>{renderHTML(item)}</strong></li>):
          (<li key={key}><strong>{item[0]}</strong>: {renderHTML(item[1])}</li>);
  }
}

export default Credits;



// WEBPACK FOOTER //
// ./src/Credits.js